// extracted by mini-css-extract-plugin
module.exports = {"content":"Accessories_content__GyW6h"};